module.exports = {
    ok:'確定',
    close:'關閉',
    please: '请在',
    hour: '小時',
    minutes:'分钟',
    pay_countdown:'之內完成支付，剩餘支付時間',
    order_cancel:'秒內完成支付，否則訂單取消！',
    pay_wechat:'微信支付',
    min:'分',
    overtime_refresh:'秒內完成支付，逾時二維碼將逾期，請重新整理頁面重新獲取。',  
    color_black: '曜石黑',
    color_orange: '愛馬仕橙',
    color_blue: '科技藍'   
}


// WEBPACK FOOTER //
// ./js/src/i18n/salecomponents/hk.js